module.exports = __webpack_public_path__ + "media/images/computer-p-1600-6199839c4830712cda436b69a046feb6.jpeg";